export default __webpack_public_path__ + "static/media/BlackLozengeGlow.fe65b1fc.png";